import { Helpers } from '../../helpers';
import { IAsset } from '../../interfaces/iasset';
import { Area } from '../area';
import { AssetStatus } from '../asset-status';
import { AssetTeam } from '../asset-team';
import { AssetThirdPartyConstraint } from '../asset-third-party-constraint';
import { AssetType } from '../asset-type';
import { CostCenter } from '../cost-center';
import { County } from '../county';
import { Pad } from '../pad';
import { Pipeline } from '../pipeline';
import { Pond } from '../pond';
import { ProductionStatus } from '../production-status';
import { ProjectAssetMapping } from '../project-asset-mapping';
import { ProjectPondParameter } from '../project-pond-parameter';
import { SaltWaterDisposalFacility } from '../salt-water-disposal-facility';
import { SaltWaterDisposalWell } from '../salt-water-disposal-well';
import { ScenarioAssetMapping } from '../scenario-asset-mapping';
import { ScenarioFacilityCapacity } from '../scenario-facility-capacity';
import { State } from '../state';
import { TankBattery } from '../tank-battery';
import { Township } from '../township';
import { WaterDisposalSystem } from '../water-disposal-system';
import { WaterWell } from '../water-well';
import { Well } from '../well';

export class AssetBase {
  AssetId: number;
  AssetName: string | null;
  AssetTypeId: number | null;
  CostCenterId: number | null;
  FirstProductionDate: Date | null;
  PlugAndAbandonDate: Date | null;
  ProducingStatusDate: Date | null;
  ProductionStatusId: number | null;
  ZipCode: string | null;
  GeoCenter: object | null;
  IsActive: boolean;
  Class: string | null;
  Comments: string | null;
  LegacyAssetId: string | null;
  CountyId: number | null;
  Location: string | null;
  AssetTeamId: number | null;
  IsInsideCityLimits: boolean | null;
  StateId: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  AssetStatusId: number | null;
  DevelopmentAreaId: number | null;
  DrillingAreaId: number | null;
  CompletionsAreaId: number | null;
  TypeCurveAreaId: number | null;
  HorizontalOpsAreaId: number | null;
  TankBatteryAreaId: number | null;
  WaterDisposalSystemAreaId: number | null;
  PIGAreaId: number | null;
  TownshipId: number | null;

  AssetThirdPartyConstraints_Asset?: Array<AssetThirdPartyConstraint> | null;
  Pads_Asset?: Array<Pad> | null;
  Pipelines_Asset?: Array<Pipeline> | null;
  Ponds_Asset?: Array<Pond> | null;
  ProjectAssetMappings_Asset?: Array<ProjectAssetMapping> | null;
  ProjectPondParameters_Asset?: Array<ProjectPondParameter> | null;
  SaltWaterDisposalFacilities_Asset?: Array<SaltWaterDisposalFacility> | null;
  SaltWaterDisposalWells_Asset?: Array<SaltWaterDisposalWell> | null;
  ScenarioFacilityCapacities_Asset?: Array<ScenarioFacilityCapacity> | null;
  TankBatteries_Asset?: Array<TankBattery> | null;
  WaterWells_Asset?: Array<WaterWell> | null;
  Wells_Asset?: Array<Well> | null;
  ScenarioAssetMappings_SourceAsset?: Array<ScenarioAssetMapping> | null;
  ScenarioAssetMappings_TargetAsset?: Array<ScenarioAssetMapping> | null;
  WaterDisposalSystems_Asset?: Array<WaterDisposalSystem> | null;
  AssetStatus?: AssetStatus;
  AssetTeam?: AssetTeam;
  AssetType?: AssetType;
  CostCenter?: CostCenter;
  County?: County;
  ProductionStatus?: ProductionStatus;
  State?: State;
  Township?: Township;
  CompletionsArea?: Area;
  DevelopmentArea?: Area;
  DrillingArea?: Area;
  HorizontalOpsArea?: Area;
  PIGArea?: Area;
  TankBatteryArea?: Area;
  TypeCurveArea?: Area;
  WaterDisposalSystemArea?: Area;

  constructor(item?: IAsset) {
    if (item) {

      this.AssetId = item.AssetId;
      this.AssetName = item.AssetName;
      this.AssetTypeId = item.AssetTypeId;
      this.CostCenterId = item.CostCenterId;
      this.FirstProductionDate = item.FirstProductionDate ? new Date(item.FirstProductionDate) : null;
      this.PlugAndAbandonDate = item.PlugAndAbandonDate ? new Date(item.PlugAndAbandonDate) : null;
      this.ProducingStatusDate = item.ProducingStatusDate ? new Date(item.ProducingStatusDate) : null;
      this.ProductionStatusId = item.ProductionStatusId;
      this.ZipCode = item.ZipCode;
      this.GeoCenter = item.GeoCenter;
      this.IsActive = item.IsActive;
      this.Class = item.Class;
      this.Comments = item.Comments;
      this.LegacyAssetId = item.LegacyAssetId;
      this.CountyId = item.CountyId;
      this.Location = item.Location;
      this.AssetTeamId = item.AssetTeamId;
      this.IsInsideCityLimits = item.IsInsideCityLimits;
      this.StateId = item.StateId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.AssetStatusId = item.AssetStatusId;
      this.DevelopmentAreaId = item.DevelopmentAreaId;
      this.DrillingAreaId = item.DrillingAreaId;
      this.CompletionsAreaId = item.CompletionsAreaId;
      this.TypeCurveAreaId = item.TypeCurveAreaId;
      this.HorizontalOpsAreaId = item.HorizontalOpsAreaId;
      this.TankBatteryAreaId = item.TankBatteryAreaId;
      this.WaterDisposalSystemAreaId = item.WaterDisposalSystemAreaId;
      this.PIGAreaId = item.PIGAreaId;
      this.TownshipId = item.TownshipId;

      this.AssetThirdPartyConstraints_Asset = Helpers.createClassArray(AssetThirdPartyConstraint, item.AssetThirdPartyConstraints_Asset);
      this.Pads_Asset = Helpers.createClassArray(Pad, item.Pads_Asset);
      this.Pipelines_Asset = Helpers.createClassArray(Pipeline, item.Pipelines_Asset);
      this.Ponds_Asset = Helpers.createClassArray(Pond, item.Ponds_Asset);
      this.ProjectAssetMappings_Asset = Helpers.createClassArray(ProjectAssetMapping, item.ProjectAssetMappings_Asset);
      this.ProjectPondParameters_Asset = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_Asset);
      this.SaltWaterDisposalFacilities_Asset = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_Asset);
      this.SaltWaterDisposalWells_Asset = Helpers.createClassArray(SaltWaterDisposalWell, item.SaltWaterDisposalWells_Asset);
      this.ScenarioFacilityCapacities_Asset = Helpers.createClassArray(ScenarioFacilityCapacity, item.ScenarioFacilityCapacities_Asset);
      this.TankBatteries_Asset = Helpers.createClassArray(TankBattery, item.TankBatteries_Asset);
      this.WaterWells_Asset = Helpers.createClassArray(WaterWell, item.WaterWells_Asset);
      this.Wells_Asset = Helpers.createClassArray(Well, item.Wells_Asset);
      this.ScenarioAssetMappings_SourceAsset = Helpers.createClassArray(ScenarioAssetMapping, item.ScenarioAssetMappings_SourceAsset);
      this.ScenarioAssetMappings_TargetAsset = Helpers.createClassArray(ScenarioAssetMapping, item.ScenarioAssetMappings_TargetAsset);
      this.WaterDisposalSystems_Asset = Helpers.createClassArray(WaterDisposalSystem, item.WaterDisposalSystems_Asset);
      this.AssetStatus = new AssetStatus(item.AssetStatus);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.AssetType = new AssetType(item.AssetType);
      this.CostCenter = new CostCenter(item.CostCenter);
      this.County = new County(item.County);
      this.ProductionStatus = new ProductionStatus(item.ProductionStatus);
      this.State = new State(item.State);
      this.Township = new Township(item.Township);
      this.CompletionsArea = new Area(item.CompletionsArea);
      this.DevelopmentArea = new Area(item.DevelopmentArea);
      this.DrillingArea = new Area(item.DrillingArea);
      this.HorizontalOpsArea = new Area(item.HorizontalOpsArea);
      this.PIGArea = new Area(item.PIGArea);
      this.TankBatteryArea = new Area(item.TankBatteryArea);
      this.TypeCurveArea = new Area(item.TypeCurveArea);
      this.WaterDisposalSystemArea = new Area(item.WaterDisposalSystemArea);
    }
  }
}